import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'helukabel',
} as IModuleProps;
